import PropTypes from 'prop-types';
import { MoonLoader } from 'react-spinners';

import Input from 'components/input/input';
import FileUpload from 'components/upload/upload';
import { userShape } from 'helpers/shared_types';

const MobileProfileInputs = ({
  user,
  avatar,
  validation,
  loading,
  onChange,
  onFileUpload,
}) => {
  return (
    <>
      <h4 className="midlightgrey f-small fw5 ttu">General info</h4>
      <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column">
        <div className="w-100 flex flex-column justify-between margin-between">
          <Input
            name="firstName"
            className="w-100"
            valid={validation.firstName}
            label="First Name*"
            value={user.firstName}
            onChange={onChange}
          />
          <Input
            name="lastName"
            className="w-100"
            valid={validation.lastName}
            label="Last Name*"
            value={user.lastName}
            onChange={onChange}
          />
          <Input
            name="email"
            className="w-100"
            valid={true}
            label="Email*"
            disabled
            value={user.email}
            onChange={onChange}
          />
        </div>
        {loading ? (
          <div
            className="flex flex-column justify-center items-center"
            style={{ height: '298px' }}
          >
            <MoonLoader color="#455d7a" size={60} />
          </div>
        ) : (
          <FileUpload
            name="avatar"
            label="Avatar"
            accept="image/*"
            valid={true}
            value={avatar}
            onFileUpload={onFileUpload}
          />
        )}
      </div>
    </>
  );
};

MobileProfileInputs.propTypes = {
  user: userShape,
  isValid: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onFileUpload: PropTypes.func.isRequired,
};

export default MobileProfileInputs;
